import { Typography } from '@mui/material';

export const Screen10DecisionCriteria = ({ selectedIndustry }) => {
  if (!selectedIndustry) return null;

  return (
    <div className="p-6">
      <Typography fontSize={35} textAlign="center">
        Decision Criteria
      </Typography>
      <Typography fontSize={24} mt={4} lineHeight={1}>
        Key Criteria when choosing your AI tech solution partner:
      </Typography>

      {selectedIndustry.DecisionCriteria.map((criteria, index) => (
        <div className="flex px-2" key={index}>
          <Typography fontSize={22} mt={2.2} lineHeight={1.3}>
            {index + 1}.
          </Typography>
          <Typography fontSize={22} mt={2} lineHeight={1.3} ml={1}>
            {criteria}
          </Typography>
        </div>
      ))}
    </div>
  );
};
